
const MicrophoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.25 7.5V9C14.25 11.8995 11.8995 14.25 9 14.25M3.75 7.5V9C3.75 11.8995 6.10051 14.25 9 14.25M9 14.25V16.5M6 16.5H12M9 11.25C7.75736 11.25 6.75 10.2426 6.75 9V3.75C6.75 2.50736 7.75736 1.5 9 1.5C10.2426 1.5 11.25 2.50736 11.25 3.75V9C11.25 10.2426 10.2426 11.25 9 11.25Z" stroke="#0E092A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default MicrophoneIcon
